window.upcartOnItemRemoved = (_, item) => {
    // Get the cart contents
    fetch('/cart.js')
        .then(response => response.json())
        .then(cart => {
            // Check if there's only one item in the cart
            if (cart.items.length === 1) {
                // Check if the single item is the one with the specified variant ID
                if (cart.items[0].variant_id === 49290730078509) {
                    // Remove the item from the cart
                    fetch('/cart/change.js', {
                        method: 'POST',
                        headers: {
                            'Content-Type': 'application/json'
                        },
                        body: JSON.stringify({
                            id: cart.items[0].key,
                            quantity: 0
                        })
                    }).then(response => response.json())
                      .then(data => {
                          console.log('Item removed:', data);
                          // Refresh the cart UI
                          window.upcartRefreshCart();
                      })
                      .catch(error => {
                          console.error('Error removing item:', error);
                      });
                }
            }
        })
        .catch(error => {
            console.error('Error fetching cart:', error);
        });
};
